<template>
  <div>
    <div class="rulesContent" :class="theme==0?'dark':'white'">
      <!-- <div class="topBox">
        <img
          src="/static/img/index/back.png"
          alt=""
          class="ic-arrow-line-leftImg"
          @click="goBack()"
        />
      </div> -->
      <div class="rulesDes">
        <div class="title">
          <!-- 抽签码规则  -->
          {{$t('detailedRules.text1')}}
        </div>
        <div class="rulesDesView">
          <div class="text1">
            <!-- 一、参与对象 -->
            {{$t('detailedRules.text2')}}
          </div>
          <div class="text2">
            <!-- 薄盒平台注册用户 -->
            {{$t('detailedRules.text3')}}
          </div>
        </div>
        <div class="rulesDesView">
          <div class="text1">
            <!-- 二、活动规则 -->
            {{$t('detailedRules.text4')}}
          </div>
          <div class="text2">
            <!-- 1、用户在活动期间内进入抽签活动页面，在指定活动时间内完成登记，即可获得一个抽签码；在活动指定时间内将活动页面分享给其他用户并获得其助力，可获得更多抽签码。 -->
            {{$t('detailedRules.text5')}}
            <br />
            {{$t('detailedRules.text6')}}
            <!-- 2、发签结束后平台将在所有成功发放的抽签码中随机抽取一定数量的中签用户，并于该活动页面进行公示，领取到中签码的用户即可成功获得免费盲盒奖品。 -->
            <br />
            <!-- 3、同一用户最多可有4个抽签码有机会中签，若抽取到多个中签码属于同一用户，则领取盲盒时，可领取到多个盲盒。 -->
            {{$t('detailedRules.text7')}}
            <br />
            <!-- 4、为了保证活动公平，不同用户ID，但存在下列情况的：同一个设备号、同一个身份认证信息、同一个支付信息等能判定为同一人的均视为同一用户，同一用户下，最多可获得4个奖品。 -->
            {{$t('detailedRules.text8')}}
            <br />
            {{$t('detailedRules.text9')}}
            <!-- 5、奖单公示后，盲盒领取时间为3小时，超过领取时限后盲盒奖品将无法领取，视为用户主动放弃中奖资格，薄盒平台不提供任何形式的补偿。 -->
          </div>
        </div>
        <div class="rulesDesView">
          <div class="text1">
            <!-- 三、特别说明 -->
            {{$t('detailedRules.text10')}}
          </div>
          <div class="text2">
            <!-- 1、活动期间，为了保证活动公平，如发现用户存在违规行为（包括但不限于作弊、刷单/量、虚假交易、网络攻击、或者损害其他用户、薄盒平台及任何第三方合法权益的行为等），薄盒平台将有权撤销用户活动资格、取消全部抽签码及盲盒领取资格、暂定且限制薄盒平台服务（包括不限于薄盒平台上的其他形式的营销活动等）。若您已领了活动奖品，则平台有权收回您所获得的盲盒。用户因轻信第三方导致的损失，由用户自行负责。 -->
            {{$t('detailedRules.text11')}}
            <br />
            <!-- 2、由于互联网技术等客观因素，薄盒平台显示的信息可能存在一定的滞后性或差错，对此情景用户知悉并了解。因此，由于排版错误或信息错误导致活动以不正确或明显不合理的信息显示时，薄盒平台有权取消该不正确或明显不合理的盲盒订单。 -->
            {{$t('detailedRules.text12')}}
            <br />
            <!-- 3、如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障需要暂定举办的）导致活动内容发生变动（如活动规则变动、活动暂停或取消等），用户同意薄盒平台不因此承担任何责任。 -->
            {{$t('detailedRules.text13')}}
            <br />
            <!-- 4、薄盒平台有权随时变更本规则说明，变更内容一经公示即生效，若您对本规则有任何疑问，请登录至薄盒平台找线上客服咨询。 -->
            {{$t('detailedRules.text14')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        theme: 0,
      }
    },
    methods: {
      goBack() {
        this.$router.back();
      },
    },
    mounted() {
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    },
  };

</script>
<style scoped lang="less">
  .rulesContent {
    .topBox {
      height: 30px;
      position: relative;

      .ic-arrow-line-leftImg {
        position: absolute;
        top: 55px;
        left: 15px;
        width: 30px;
        height: 30px;
      }
    }

    .rulesDes {
      // height: 1025px;
      background: #0c0c0c;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      margin: 35px 15px 20px 15px;
      padding: 20px 15px;
      min-height: calc(100vh - 40px);

      .title {
        text-align: center;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 15px;
      }

      .rulesDesView {
        margin-bottom: 20px;

        .text1:nth-child(1) {
          color: #bdbdbd;
          font-size: 14px;
          font-weight: bold;
          font-family: PingFangSC-Medium, PingFang SC;
        }

        .text2:nth-child(2) {
          margin-top: 10px;
          font-size: 14px;
          // font-family: PingFangSC-Medium, PingFang SC;
          color: #83878b;
          line-height: 22px;
        }
      }
    }
  }

  .dark {
    background: #000000;

    .rulesDes {
      background: #0c0c0c;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);

      .title {
        color: #ffffff;
      }

      .rulesDesView {

        .text1:nth-child(1) {
          color: #bdbdbd;
        }

        .text2:nth-child(2) {
          color: #83878b;
        }
      }
    }

  }

  .white {
    background: #ffffff;

    .rulesDes {
      background: #f1f1f1;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);

      .title {
        color: #333333;
      }

      .rulesDesView {

        .text1:nth-child(1) {
          color: #444444;
        }

        .text2:nth-child(2) {
          color: #555555;
        }
      }
    }


  }

</style>



// WEBPACK FOOTER //
// src/views/detailedRules.vue